module.exports = __webpack_public_path__ + "static/media/xiaoxue_laoji.43deae55.png";